import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Public = ({ children }) => {
    const { userToken } = useSelector((state) => state.AuthReducer);
    return userToken ? <Navigate to="/" /> : children;
};
export default Public;
